import { Component, h, Prop, Host } from "@stencil/core";
import { ShipmentStatusType } from "../track-response";

@Component({
    tag: "ux-w-track-delivery-item",
    styleUrl: "track-delivery-item.scss",
    shadow: false
})
export class TrackDeliveryItem {
    /** Number of the delivery */
    @Prop() headline: string = "";
    /** Current status message */
    @Prop() statusText: string = "";
    /** color for the current status */
    @Prop() statusType: ShipmentStatusType;
    /** Headline over the shipping section */
    @Prop() label: string = "";
    /** formatted date or placeholder text */
    @Prop() date: string = "";
    /** Number of the order */
    @Prop() orderNumber: string = "";
    /** Link to the order detail page */
    @Prop() orderLink: string = "";
    /** Title attribute for Link to the order detail page */
    @Prop() orderLinkTitle: string = "";
    /** Tracking number for a single shipment */
    @Prop() trackingNumber: string = "";
    /** Link to the tracking page */
    @Prop() trackingLink: string = "";
    /** Linktext for the tracking link */
    @Prop() trackingLinkTitle: string = "";

    render() {
        const baseClass = "ux-w-track-delivery-item";
        const {
            orderNumber,
            orderLink,
            orderLinkTitle,
            headline,
            statusText,
            statusType,
            label,
            date,
            trackingNumber,
            trackingLink,
            trackingLinkTitle
        } = this;

        const trackingInformation =
            trackingLink === "" ? null : (
                <div>
                    {trackingNumber && (
                        <div
                            class="ux-text-tiny ux-u-text-uppercase"
                            data-testid="tracking-number"
                        >
                            {trackingNumber}
                        </div>
                    )}
                    {trackingLink && (
                        <a
                            class={`${baseClass}__tracking-link ux-text-link ux-text-link--green`}
                            href={trackingLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="tracking-link"
                        >
                            {trackingLinkTitle}{" "}
                            <ux-icon name="arrow-small-right" />
                        </a>
                    )}
                </div>
            );

        return (
            <Host
                class={baseClass}
                data-testid={`delivery-item-${orderNumber}`}
            >
                <a
                    class={`${baseClass}__order-number`}
                    href={orderLink}
                    title={orderLinkTitle}
                    data-testid="order-link"
                >
                    <span class={`${baseClass}__order-number__content`}>
                        {orderNumber}
                    </span>
                    <ux-icon
                        class={`${baseClass}__order-number__icon`}
                        name="chevron-right"
                    />
                </a>
                {headline && (
                    <div
                        class={`${baseClass}__headline ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase`}
                    >
                        {headline}
                    </div>
                )}
                <ux-w-status type={`SHIPMENT_${statusType}`}>
                    {statusText}
                </ux-w-status>
                {label && (
                    <div
                        class={`${baseClass}__label ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase`}
                    >
                        {label}
                    </div>
                )}
                {date && (
                    <div
                        class="ux-text-tiny ux-u-text-uppercase"
                        data-testid="date"
                    >
                        {date}
                    </div>
                )}
                {trackingInformation}
            </Host>
        );
    }
}
